export class EdpTableOrder {
    label: string;
    field: string;
    direction?: string;
    constructor(
        label: string,
        field: string,
        direction?: string,
    ) {
        this.label = label;
        this.field = field;
        this.direction = direction;
    }
}

export class EdpTablePaginator {
    itemsPerPage: number;
    currentPage: number;
    totalItems: number;
    maxSize: number;
    countItems: number;
    countTotalItems: number;

    constructor(
        itemsPerPage: number = 20,
        currentPage: number = 1,
        totalItems: number = 0,
        maxSize: number = 5,
    ) {
        this.itemsPerPage = itemsPerPage;
        this.currentPage = currentPage;
        this.totalItems = totalItems;
        this.maxSize = maxSize;
    }
}

export class EdpTableContext {
    page: number;
    positionY: number;

    constructor(
        page: number = 1,
        positionY: number = 0
    ) {
        this.page = page;
        this.positionY = positionY;
    }
}
